import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import Helmet from 'react-helmet'
import { Link } from 'react-router'

// Actions
import { userActions } from 'redux/actionCreators'

// Components
import { FormGroup, Loader } from 'components'

// Styles
import classes from './ForgotPassword.scss'

// Helpers
import _get from 'lodash.get'
import { validateRequired, emailIsValid, hasError, inputProps } from 'helpers/formHelpers'

const mapStateToProps = (state) => ({
  attempting: _get(state, ['user', 'forgotPasswordAttempting']) || false,
  attempted: _get(state, ['user', 'forgotPasswordAttempted']) || false
})
const mapDispatchToProps = (dispatch) => ({
  attemptForgotPassword: (payload) =>
    dispatch(userActions.attemptForgotPassword(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({ form: 'ForgotPassword', fields: ['email'] })
class ForgotPassword extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    attemptForgotPassword: PropTypes.func.isRequired
  };

  static contextTypes = { router: PropTypes.object.isRequired };

  constructor (props) {
    super(props)
    this.state = { emailError: '' }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  _validateInput = () => {
    const { attempting, fields } = this.props
    let error = validateRequired(fields.email.value, 'email')
    if (!error.emailError && !emailIsValid(fields.email.value)) {
      error = { ...error, emailError: 'รูปแบบอีเมล์ไม่ถูกต้อง' }
    }

    this.setState(error)
    return !attempting && !hasError(error)
  }

  _onSubmit = () => {
    if (this._validateInput()) {
      const { attemptForgotPassword, fields: { email } } = this.props
      attemptForgotPassword({ email: email.value })
    }
  }

  _onOkay = () => this.context.router.replace('/');

  render () {
    const { attempting, attempted, fields: { email } } = this.props
    return (
      <div id='forgot-password-page' className='page-wrapper'>
        <Helmet title='ลืมรหัสผ่าน' />
        <div className='hero'>
          <Link to='/'>
            <img className='logo' src='/images/logo.png' alt='logo' />
          </Link>
          <div className='underline' />
        </div>
        <div className={classes.header}>
          <img src='/images/icon-question.png' alt='icon-question' />
          <span>ลืมรหัสผ่าน</span>
        </div>
        <div className={classes.info}>
          <span>กรุณากรอกอีเมล์ของคุณค่ะ ระบบจะทำการส่งลิงก์สำหรับเปลี่ยนแปลงรหัสผ่านไปยัง Email ที่คุณได้ลงทะเบียนไว้ค่ะ</span>
        </div>
        <div className={classes.body}>
          <FormGroup title='อีเมล์' centered errorMessage={this.state.emailError}>
            <input type='text' placeholder='กรุณากรอกอีเมล์ของคุณ' {...inputProps(email)} />
          </FormGroup>
          <div className={classes.button} onClick={this._onSubmit}>
            {attempting ? <Loader /> : <span>ตกลง</span>}
          </div>
        </div>
        {attempted && (
          <div className='overlay'>
            <div className='overlay-cell'>
              <div className='lightbox'>
                <div className='line1'>
                  <span>สำเร็จ!</span>
                </div>
                <div className='line2'>
                  <div>ระบบได้ทำการส่งลิงก์สำหรับเปลี่ยนแปลงรหัสผ่านไปยัง Email ที่คุณได้ลงทะเบียนไว้แล้ว</div>
                  <div>ลิงก์จะมีอายุการใช้งาน 24 ชั่วโมงเท่านั้น ขอบคุณค่ะ</div>
                </div>
                <div className='line3'>
                  <div>พบปัญหาการใช้งานหรือต้องการสอบถามข้อมูลเพิ่มเติมติดต่อ 063-464-6194, 063-464-6195, 063-464-6196</div>
                  <div>วันจันทร์ - วันเสาร์​เวลา 9.00 - 18.00 น. หรือ Email chatchaipharmacy@gmail.com</div>
                </div>
                <img className='mascot' src='/images/mascot.png' alt='mascot' />
                <div className='btn-close' onClick={this._onOkay}>X</div>
                <div className='btn-ok' onClick={this._onOkay}>
                  <span>ตกลง</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js